import * as React from "react";
import {
  GameSummaryHeading,
  ButtonsContainer,
  EndGameConfirmationPopup,
} from "src/components/Header/Navbars/InGameNav/GameSummaryModal/GameSummaryModal.components";
import { displayErrorToast } from "src/components/shared/Toasts/Toast";
import DefaultModalWrapper from "src/components/shared/Modal/DefaultModalWrapper";
import { useModal } from "src/components/shared/Modal";
import { useGameContext } from "src/game/useGameContext";
import { UserRole } from "src/enums/user/userRoles";
import { ToastIds } from "src/enums/errorToastIds";
import GameSummaryTaskList from "./GameSummaryTaskList";
import ButtonBordered from "src/components/shared/Button/ButtonBordered";
import useIsMobile from "src/hooks/useIsMobile";

export interface Props {
  onGameEnd: () => void;
}

const GameSummaryModal: React.FunctionComponent<Props> = ({ onGameEnd }) => {
  const { closeModal, isOpen } = useModal();
  const {
    gameState,
    actionHandlers: { finishGame },
  } = useGameContext();

  const isMobile = useIsMobile();

  const [endGamePopupOpen, setEndGamePopupOpen] = React.useState(false);

  React.useEffect(() => {
    if (endGamePopupOpen && !isOpen) {
      setEndGamePopupOpen(false);
    }
  }, [isOpen]);

  const handleFinishGame = async () => {
    if (!gameState.game || !gameState.token) {
      return;
    }
    try {
      const response = await finishGame({
        token: gameState.token,
        gameId: gameState.game?.id,
      });
      if (response.error) {
        displayErrorToast(
          `Failed to end the game  ${response.error.message}`,
          ToastIds.GAME_END_FAILED
        );
      } else {
        onGameEnd();
        setEndGamePopupOpen(false);
      }
    } catch (e) {
      displayErrorToast("Failed to end the game", ToastIds.GAME_END_FAILED);
    }
  };

  return (
    <DefaultModalWrapper>
      <GameSummaryHeading>Game Summary</GameSummaryHeading>
      <GameSummaryTaskList />
      <ButtonsContainer
        centeredButtons={gameState.user?.role !== UserRole.OWNER}>
        <ButtonBordered themeColor="background" onClick={closeModal}>
          {isMobile ? "Back" : "Back to the game"}
        </ButtonBordered>
        {gameState.user?.role === UserRole.OWNER && (
          <ButtonBordered
            themeColor="buttonPrimary"
            onClick={() => setEndGamePopupOpen(true)}>
            End the game
          </ButtonBordered>
        )}
      </ButtonsContainer>
      {endGamePopupOpen && (
        <EndGameConfirmationPopup
          onCancel={() => setEndGamePopupOpen(false)}
          onConfirm={handleFinishGame}
        />
      )}
    </DefaultModalWrapper>
  );
};

export default GameSummaryModal;
